export const STORE = 'VERIFICATION_EMAIL';
export const GET_IS_LOADING_CONFIRM = 'GET_IS_LOADING_CONFIRM';
export const GET_SHOW_ALERT = 'GET_SHOW_ALERT';
export const GET_ALERT_MESSAGE = 'GET_ALERT_MESSAGE';
export const CONFIRM_EMAIL = 'CONFIRM_EMAIL';
export const SET_LOADING_CONFIRM = 'SET_LOADING_CONFIRM';
export const SET_ALERT_MESSAGE = 'SET_ALERT_MESSAGE';
export const SET_COMPLETE_NEW_REGISTER = 'SET_COMPLETE_NEW_REGISTER';
export const GET_COMPLETE_NEW_REGISTER = 'GET_COMPLETE_NEW_REGISTER';
